"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _errors = require('shared/errors');

// Shown as-is by screens that display response.Error. Cloud Armor returns 429
// when one IP calls sign-up or 2FA endpoints too often (TM-806).
 const TOO_MANY_REQUESTS_MESSAGE = 'Too many attempts from your network. Please wait a few minutes and try again.'; exports.TOO_MANY_REQUESTS_MESSAGE = TOO_MANY_REQUESTS_MESSAGE
























// Upload progress rides on the request's AbortSignal, which already reaches
// every upload call, so no call signature has to change to carry it. A request
// whose signal has a listener goes over XMLHttpRequest, the only transport with
// upload progress events on both web and React Native.
const uploadProgressListeners = new WeakMap()

 const onUploadProgress = (signal, listener) => {
  uploadProgressListeners.set(signal, listener)
}; exports.onUploadProgress = onUploadProgress

// The parts of a fetch Response the code below (and RestError readers) use.









const abortError = () => {
  const error = new Error('Aborted')
  error.name = 'AbortError'
  return error
}

 const xhrRequest = (
  url,
  init,
  onProgress,
) => new Promise((resolve, reject) => {
  const xhr = new XMLHttpRequest()
  const { signal } = init
  if (_optionalChain([signal, 'optionalAccess', _ => _.aborted])) {
    reject(abortError())
    return
  }
  const onAbort = () => xhr.abort()
  _optionalChain([signal, 'optionalAccess', _2 => _2.addEventListener, 'optionalCall', _3 => _3('abort', onAbort)])
  const done = () => _optionalChain([signal, 'optionalAccess', _4 => _4.removeEventListener, 'optionalCall', _5 => _5('abort', onAbort)])

  xhr.open(init.method, url)
  xhr.withCredentials = init.credentials === 'include'
  xhr.upload.onprogress = (event) => {
    onProgress(event.loaded, event.lengthComputable ? event.total : 0)
  }
  xhr.onload = () => {
    done()
    const text = xhr.responseText
    resolve({
      status: xhr.status,
      url: xhr.responseURL || url,
      headers: { get: (name) => xhr.getResponseHeader(name) },
      json: () => Promise.resolve().then(() => JSON.parse(text)),
    })
  }
  // Same shapes fetch rejects with, so the handling below is shared.
  xhr.onerror = () => { done(); reject(new TypeError('Network request failed')) }
  xhr.ontimeout = () => { done(); reject(new TypeError('Network request failed')) }
  xhr.onabort = () => { done(); reject(abortError()) }
  xhr.send(_nullishCoalesce(init.body, () => ( null)))
}); exports.xhrRequest = xhrRequest

 class Fetch {
  
  constructor (baseURL) {;Fetch.prototype.__init.call(this);Fetch.prototype.__init2.call(this);
    this.baseURL = baseURL
  }

  // The full URL of an API path, for requests made outside this client (the
  // native uploader's upload completion).
  __init() {this.restURL = (path) => `${this.baseURL}${path}`}

   __init2() {this.fetch = async (
    url,
    method = "GET",
    data,
    headerDispatch,
    signal,
  ) => {
    let body
    if (data) {
      body = new FormData()
      for (const name in data) {
        const value = data[name]
        // Check for React Native file object (has uri property)
        if (value && typeof value === 'object' && 'uri' in value) {
          // React Native file format for FormData
          body.append(name, value )
        } else if (value instanceof Blob || value instanceof File) {
          // For Blob/File objects, append them directly
          body.append(name, value, (value ).name)
        } else {
          // For primitive values, convert to string
          body.append(name, value )
        }
      }
    }

    const onProgress = body && signal ? uploadProgressListeners.get(signal) : undefined
    const request = onProgress
      ? exports.xhrRequest.call(void 0, `${this.baseURL}${url}`, { credentials: 'include', method, signal, body }, onProgress)
      : fetch(`${this.baseURL}${url}`, {
        credentials: 'include',
        method,
        signal,
        body,
      })
    return request.then(response => {
      if (headerDispatch && response.headers.get('Set-Cookie')) {
        /* Note to posterity: this code isn't really designed to run anywhere that isn't
         * an advanced browser or react native environment, and doesn't really matter outside of
         * react-native for android since this is the only place where reducer-stored cookies
         * are significant.
         */
        headerDispatch({
          type: "SET_LOGIN_COOKIES",
          setCookieHeader: response.headers.get("Set-Cookie") || '',
          url: response.url,
        })
      }

      if (response.status === 204) return { Error: false }
      if (response.status === 429) {
        // Keep the body's fields (RetryAfterSeconds on the patient sign-in
        // routes) while still marking the error transient. A 429 from the edge
        // (Cloud Armor) has no JSON body, so it gets readable words.
        const transient = { Error: exports.TOO_MANY_REQUESTS_MESSAGE, ServerError: false, Transient: true }
        if (!_optionalChain([response, 'access', _17 => _17.headers, 'access', _18 => _18.get, 'call', _19 => _19("content-type"), 'optionalAccess', _20 => _20.includes, 'call', _21 => _21("application/json")])) return transient
        return response.json().then(
          (body) => ({ ...body, ...transient, Error: _optionalChain([body, 'optionalAccess', _22 => _22.Error]) || exports.TOO_MANY_REQUESTS_MESSAGE }),
          () => transient,
        )
      }
      if (response.status >= 200 && response.status < 300) return response.json()
      if (_optionalChain([response, 'access', _23 => _23.headers, 'access', _24 => _24.get, 'call', _25 => _25("content-type"), 'optionalAccess', _26 => _26.includes, 'call', _27 => _27("application/json")])) {
        return response.json()
      }

      return Promise.reject(new (0, _errors.RestError)(method, url, response ))
    })
      .then(data => data.Error || data.ServerError
        ? Promise.reject(new (0, _errors.RestError)(method, url, data))
        : data,
      )
      .catch((e) => {
        if (!(e instanceof _errors.RestError)) { // 'Network request failed'
          e = new (0, _errors.RestError)(method, url, { Error: true, Transient: true })
        }
        return Promise.reject(e)
      })
  }}
} exports.Fetch = Fetch;
